<template lang="pug">
section.main(:class="collapsed ? 'wide' : 'narrow'")
  Header(ref="header")
  Menu
  section.page.users(v-if="$auth.isAuthenticated && currentUser")
    h1.title
      i.icon.fas.fa-address-card
      span {{ page.title }}

      b-button.position-absolute.ml-2(v-if="currentUser && currentUser.acl && currentUser.acl.users && currentUser.acl.users.post",style="right:1.5rem",size="sm",variant="primary",:disabled="!currentUser || !currentUser.acl || !currentUser.acl.users || !currentUser.acl.users.post",v-b-modal.modal-add)
        i.fas.fa-user-plus
        // i.fas.fa-plus
        span.ml-2 メンバーの追加

    template(v-if="currentUser && currentUser.role !== 'agent'")
      section.body(ref="body")
        .lock(ref="lock",v-show="lock",@click="unlock()")
        b-navbar
          //-b-navbar-nav.feature
            b-dropdown(size="sm",variant="outline-secondary")
              template(v-slot:button-content)
                i.fas.fa-ellipsis-v
          b-navbar-nav
            b-button(size="sm",variant="link",v-if="!toggleSearch",@click="toggleSearch=true")
              i.fas.fa-search
            b-nav-form.search(@submit.prevent)
              b-input-group(size="sm",v-if="toggleSearch")
                b-form-input(size="sm",v-model="filters.keyword",placeholder="氏名・部署・役職の一部で検索")
                b-input-group-append
                  b-button(size="sm",@click="toggleSearch=false")
                    i.fas.fa-times
            b-nav-form.filters.ml-3(inline)
              b-input-group(size="sm")
                b-form-select(size="sm",v-model="filters.role",:options="options.role")
              b-input-group.ml-2(size="sm")
                b-form-select(size="sm",v-model="filters.authorized",:options="options.authorized")

        section.list
          b-table.data(ref="table",responsive,sticky-header,no-local-sorting,:items="data",:fields="fields",:sort-by="sort",:sort-desc="desc",@sort-changed="sortChanged",select-mode="single",selectable,@row-selected="rowSelected")
            template(v-slot:cell(loggedinAt)="row")
              span.loggedinAt(v-if="row.item.loggedinAt") {{loggedinAt(row.item.loggedinAt)}}
              template(v-else)
                span.notLoggedin(:class="(currentUser && currentUser.acl && currentUser.acl.users && currentUser.acl.users.post) ? 'clickable' : ''",@click.stop="onResend(row)") 未ログイン
            template(v-slot:cell(menu)="row")
              b-dropdown(variant="link")
                template(v-slot:button-content)
                  i.fas.fa-ellipsis-h
          b-navbar
            b-navbar-nav
              b-button.mr-2(size="sm",variant="link",@click="loadData")
                i.fas.fa-sync-alt
              b-nav-text.ml-2.text-muted.small {{ (currentPage - 1) * perPage + 1 }} -
                template(v-if="filteredCount === allCount")
                  span.ml-1 {{ perPage > allCount ? allCount : perPage }}
                  span.ml-2 /
                  span.ml-2 {{ allCount }} 件
                template(v-else)
                  span.ml-1 {{ perPage > filteredCount ? filteredCount : perPage }}
                  span.ml-2 /
                  span.ml-2 {{ allCount }} 件中、該当 {{ filteredCount }} 件

            b-nav-form.form-inline.ml-auto.mr-3
              label.small.mr-2 表示件数
              b-form-select(size="sm",v-model="perPage",:options="optionsPerPage")

            b-navbar-nav
              b-pagination.py-0.my-0.ml-auto.mr-2.align-items-center(v-if="filteredCount",v-model="currentPage",:per-page="perPage",:total-rows="filteredCount")

    template(v-else)
      .text-center.my-5.py-5.text-danger 設定されている権限では本機能はご利用できません

  b-modal#modal-add(size="lg",@show="initModal()")
    template(slot="modal-title")
      h5.modal-title メンバーの追加
        small.text-muted.ml-2 現在のメンバー数: {{allCount}}名

    b-card(title="")
      b-card-title
        .title.float-left 1メンバーあたり880円（税込）/月
        .sub-title.ml-2.float-left ※エージェント、採用コンサルタントは0円で追加可能です。
        .sub-title.float-right 追加したメンバーの利用料金は翌月から発生します。（初月無料）

    ValidationObserver(slim,ref="addUsersObserver")
      b-form.text-left(ref="add",:class="addUsers.mode",autocomplete="off",@submit.prevent)
        b-container(fluid)
          b-row.my-3
            b-col
              .text-left
                span(v-if="addUsers.mode === 'input'") 追加したいメンバーを入力してください
                span(v-if="addUsers.mode === 'confirm'") 追加するメンバー（{{ addUsers.data.length }}名）
          b-row.mt-3(v-for="(datum, index) in addUsers.data",:key="index")
            b-col
              b-form-group.mb-0(label="",:label-for="`input-name_${index}`",description="")
                ValidationProvider(rules="required",:name="`氏名(${index + 1}行目)`",v-slot="{ errors }")
                  b-form-input.input-name(:id="`input-name_${index}`",v-model="datum.name",type="text",autocomplete="off",placeholder="氏名を入力",@input="checkAddUsers",:disabled="!addUsers.editable",:readonly="!addUsers.editable")
                  .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
            b-col.px-0
              b-form-group.mb-0(label="",:label-for="`input-role_${index}`",description="")
                ValidationProvider(rules="required",:name="`権限(${index + 1}行目)`",v-slot="{ errors }")
                  b-form-select.input-role(:id="`input-role_${index}`",v-model="datum.role",:options="addUsers.options.role",autocomplete="off",placeholder="利用権限を選択",@change="checkAddUsers",:disabled="!addUsers.editable",:readonly="!addUsers.editable")
                  .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
            b-col.mr-5
              b-form-group.mb-0(label="",:label-for="`input-email_${index}`",description="")
                ValidationProvider(rules="required|email",:name="`Email(${index + 1}行目)`",v-slot="{ errors }")
                  b-form-input.input-email(:id="`input-email_${index}`",v-model="datum.email",type="email",autocomplete="off",placeholder="Emailを入力",@input="checkAddUsers",:disabled="!addUsers.editable",:readonly="!addUsers.editable")
                  .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
            b-button.px-2.position-absolute.removeAddUsers(v-if="addUsers.mode === 'input'",variant="link",@click="removeAddUsers(index)",:disabled="addUsers.data.length <= 1",style="right: 1.25rem")
              i.menu-icon.fas.fa-minus-circle
          b-row(v-if="addUsers.mode === 'input'")
            b-col
              b-button.pl-2.addAddUsers(variant="link",@click="addAddUsers()")
                i.fas.fa-plus-circle
                span.ml-2 もう１つ追加する
          b-row(v-if="addUsers.mode === 'confirm'")
            b-col.mt-4.mb-2
              .border.rounded.bg-white
                ul.p-3.ml-3.mb-0
                  li 追加するメンバーに関しては、1メンバーあたり「880円（税込）/月」の利用料金が発生します。
                  li メンバーの権限が「エージェント」および「採用コンサルタント」の場合は利用料金は発生しません。
                  li 追加したメンバーの利用料金は翌月から発生します。（初月無料）
                  li 追加したメンバーが本サービスにログインしなかった場合も該当メンバーを削除しない限り、利用料金が発生します。ご了承ください。
    template(v-slot:modal-footer="{ ok, cancel }")
      b-button(v-if="addUsers.mode === 'input'",variant="secondary",@click="$bvModal.hide('modal-add')") キャンセル
      b-button(v-if="addUsers.mode === 'confirm'",variant="secondary",@click="onAddUsersBack()") 入力に戻る
      b-button(variant="primary",@click="onAddUsers()",:disabled="!addUsers.valid")
        span(v-if="addUsers.mode === 'input'") 申し込み内容の確認
        span(v-if="addUsers.mode === 'confirm'") この内容で申し込む
</template>

<script>
import { cloneDeep, debounce } from 'lodash'

import QueryHash from 'query-hash'
import { getData, postData } from '../utils/api'

import { clone, getRoleTitle, optionsRole } from '../utils/libs'

import 'dayjs/locale/ja'
import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'

dayjs.locale('ja')
dayjs.extend(localizedFormat)

const page = {
  id: 'users',
  title: 'メンバー一覧'
}

export default {
  name: page.id,
  data () {
    return {
      mask: false,
      lock: false,
      page: page,
      collapsed: true,
      currentUser: null,
      showDetail: false,
      useFilter: false,
      prepared: false,
      data: [],
      params: {},
      filters: {
        role: null,
        authorized: null
      },
      options: {
        role: [],
        authorized: [
          { value: null, text: '全て' },
          { value: true, text: '承認済み' },
          { value: false, text: '未承認' }
        ]
      },
      allCount: null,
      filteredCount: null,
      currentPage: null,
      perPage: null,
      sort: 'postedAt',
      desc: true,
      defaultOrder: '-postedAt',
      toggleSearch: false,
      fields: [
        /*
        {
          key: 'selected',
          label: 'selected',
          class: 'checkbox'
        },
        */
        {
          key: 'name',
          label: '氏名',
          sortable: true
        }, {
          key: 'email',
          label: 'メールアドレス',
          sortable: true
        }, {
          key: 'role',
          label: '権限',
          sortable: false,
          formatter: (val) => {
            return getRoleTitle(val)
          }
        }, {
          key: 'loggedinAt',
          label: '最終ログイン日時',
          sortable: true
        }, {
          key: 'postedAt',
          label: '作成日時',
          sortable: true,
          formatter: (val, key, datum) => {
            return val ? dayjs(val).format('YYYY/MM/DD(ddd) HH:mm') : '-'
          }
        }
        /*
        , {
          key: 'menu',
          label: '',
          sortable: false
        }
        */
      ],
      addUsers: {
        data: [],
        mode: 'input',
        editable: true,
        valid: null,
        options: {
          role: []
        }
      },
      optionsPerPage: [
        { value: 10, text: '10件' },
        { value: 20, text: '20件' },
        { value: 50, text: '50件' },
        { value: 100, text: '100件' }
      ]
    }
  },
  watch: {
    currentPage (newVal, oldVal) {
      if (oldVal && newVal && oldVal !== newVal) {
        this.loadData()
      }
    },
    perPage (newVal, oldVal) {
      if (oldVal && newVal && oldVal !== newVal) {
        this.loadData()
      }
    },
    toggleSearch (val) {
      if (!val) {
        this.clearKeyword()
      }
    },
    'filters.keyword': debounce(function () {
      this.loadData()
    }, 1000),
    'filters.role' (val) {
      this.loadData()
    },
    'filters.authorized' (val) {
      this.loadData()
    }
  },
  mounted () {
    this.options.role = [{
      value: null,
      text: 'すべての権限'
    }].concat(optionsRole())

    this.addUsers.options.role = optionsRole()
    this.addUsers.options.role.shift()
    this.addUsers.options.role.unshift({
      value: null,
      text: '(利用権限を選択)'
    })

    for (let option of this.addUsers.options.role) {
      if (option.value === null) {
      } else if (option.value !== 'agent' && option.value !== 'consultant') {
        option.text += '（800円/月）'
      } else {
        option.text += '（無料）'
      }
    }

    if (this.$route.query.pn) {
      this.currentPage = Number(this.$route.query.pn)
    } else {
      this.currentPage = 1
    }
    if (this.$route.query.pp) {
      this.perPage = Number(this.$route.query.pp)
    } else {
      this.perPage = 10
    }

    if (this.$route.query.order) {
      if (this.$route.query.order.substring(0, 1) === '-') {
        this.desc = true
        this.sort = this.$route.query.order.substring(1)
      } else {
        this.desc = false
        this.sort = this.$route.query.order
      }
    }
  },
  methods: {
    unlock () {
    },
    loggedinAt: (val) => {
      return val ? dayjs(val).format('YYYY/MM/DD(ddd) HH:mm') : '未ログイン'
    },
    prepareData () {
      this.mask = true

      if (!this.$root.currentUser || !this.$root.currentUser.role) {
        setTimeout(() => {
          this.prepareData()
        }, 300)
        return
      }
      this.$set(this, 'currentUser', this.$root.currentUser)

      let orgRoleOptions = clone(this.options.role)
      if (this.currentUser.role === 'admin') {
      } else {
        this.options.role = []
        for (let orgRole of orgRoleOptions) {
          if (orgRole.value === null || orgRole.value !== 'admin') {
            this.options.role.push(orgRole)
          }
        }
      }

      if (this.$route.query.fk) {
        this.filters.keyword = this.$route.query.fk
        this.toggleSearch = true
      }

      if (this.$route.query.fr) {
        this.filters.role = this.$route.query.fr
      }

      if (this.$route.query.fa) {
        this.filters.authorized = this.$route.query.fa
      }

      this.prepared = true

      this.loadData()

      this.mask = false
    },
    sortChanged (obj) {
      this.sort = obj.sortBy
      this.desc = obj.sortDesc
      this.loadData()
    },
    orderChanged () {
      this.sortChanged()
    },
    async loadData () {
      this.mask = true

      this.params = {}

      let query = new QueryHash()

      let filters = []
      if (this.filters.keyword) {
        filters.push({ $or: [
          {
            name: `RegExp:('${this.filters.keyword}')`
          }, {
            $and: [
              {
                role: {
                  $in: ['agent', 'consultant']
                }
              }, {
                company: `RegExp:('${this.filters.keyword}')`
              }
            ]
          }, {
            department: `RegExp:('${this.filters.keyword}')`
          }, {
            position: `RegExp:('${this.filters.keyword}')`
          }, {
            email: `RegExp:('${this.filters.keyword}')`
          }
        ] })

        this.params.fk = this.filters.keyword
      }
      if (this.filters.role) {
        filters.push({ role: this.filters.role })

        this.params.fr = this.filters.role
      } else {
        if (this.currentUser.role !== 'admin') {
          filters.push({ role: { $ne: 'admin' } })
        }
      }

      if (this.filters.authorized !== null) {
        filters.push({ authorized: Boolean(this.filters.authorized) })

        this.params.fa = this.filters.authorized
      }

      let countQuery = new QueryHash()
      let countFilters = []
      if (this.currentUser.role !== 'admin') {
        countFilters.push({ role: { $ne: 'admin' } })
      }
      if (countFilters.length > 0) {
        countQuery.add('filter', JSON.stringify({ $and: countFilters }))
        await getData(`/users/count/?${countQuery.toQueryString()}`).then((count) => {
          this.allCount = count
          this.filteredCount = this.allCount
        })
      } else {
        await getData(`/users/count`).then((count) => {
          this.allCount = count
          this.filteredCount = this.allCount
        })
      }

      this.useFilter = false
      if (filters.length > 0) {
        this.useFilter = true

        query.add('filter', JSON.stringify({ $and: filters }))

        await getData(`/users/count/?${query.toQueryString()}`).then((count) => {
          this.filteredCount = count
        })
      }

      if (this.currentPage !== 1) {
        this.params.pn = this.currentPage
      }
      if (this.perPage !== 10) {
        this.params.pp = this.perPage
      }

      let offset = (this.currentPage - 1) * this.perPage

      let order = null
      if (this.desc) {
        order = `-${this.sort}`
      } else {
        order = this.sort
      }

      if (order !== this.defaultOrder) {
        this.params.order = order
      }

      query.add('sort', order)
      query.add('limit', this.perPage)
      if (offset !== 0) {
        query.add('skip', offset)
      }

      this.data = []
      await getData(`/users?${query.toQueryString()}`).then((data) => {
        if (data && data.length > 0) {
          this.data = cloneDeep(data)
          this.data.forEach(x => {
            if (x.company) {
              x.name = `${x.name}（${x.company}）`
            }
          })
        }
      }).catch((err) => {
        console.log(err)
      })

      this.$router.replace({ name: 'List Users', query: this.params }).catch(() => {})

      this.$refs.header.checkCondition()

      this.$refs.table.clearSelected()

      this.mask = false
    },
    clearKeyword () {
      this.filters.keyword = null
    },
    rowSelected (data) {
      if (data && data.length > 0) {
        this.handleLink(`/${this.$route.params.directory}/user/${data[0]._id}`)
      }
    },
    onResend (row) {
      if (this.currentUser.acl && this.currentUser.acl.users && this.currentUser.acl.users.post) {
        this.msgBoxConfirm('登録依頼メールを再送信しますか？', () => {
          this.doResend(row.item._id)
        })
      }
    },
    async doResend (userId) {
      this.mask = true

      let users = []
      for (let i = 0; i < this.addUsers.data.length; i++) {
        users.push(this.addUsers.data[i])
      }

      let message = null

      await postData(`/users/${userId}/resend`).then(async () => {
      }).catch((err) => {
        console.log(err)

        message = '登録依頼メールの再送信に失敗しました'
        if (err.response.data) {
          if (err.response.data.code && err.response.data.message) {
            message = err.response.data.message
          } else if (err.response.data.message) {
            message = err.response.data.message
          }
        }
      })

      this.mask = false

      if (message) {
        this.msgBoxError(message)
      } else {
        this.$bvModal.msgBoxOk('再送信が完了しました')
      }
    },
    async initModal (title) {
      let company
      await getData(`/mycompany`).then((datum) => {
        company = clone(datum)
      }).catch((err) => {
        console.log(err)
      })

      if (!company) {
        this.msgBoxError('Not Found Data', () => {
          this.$bvModal.hide('modal-add')
        })
        return
      }
      if (!company.isCreditcard) {
        this.msgBoxError('Not Set Creditcard', () => {
          this.$bvModal.hide('modal-add')
        })
        return
      }

      await getData(`/users/count`).then((count) => {
        this.allCount = count
      })

      this.addUsers.mode = 'input'
      this.addUsers.editable = true
      this.addUsers.data = [{ name: '', role: null, email: '' }]
    },
    async checkAddUsers () {
      await this.$refs.addUsersObserver.reset()
      this.addUsers.valid = await this.$refs.addUsersObserver.validate()

      return this.addUsers.valid
    },
    addAddUsers () {
      this.addUsers.data.push({ name: '', role: null, email: '' })
      this.checkAddUsers()
      this.$forceUpdate()
    },
    removeAddUsers (index) {
      this.addUsers.data.splice(index, 1)
      this.checkAddUsers()
      this.$forceUpdate()
    },
    async onAddUsers () {
      await this.checkAddUsers()
      if (!this.addUsers.valid) {
        this.msgBoxError('Invalid Inputs')
      } else {
        let isDupEmail = false
        for (let i = 0; i < this.addUsers.data.length; i++) {
          if (i + 1 < this.addUsers.data.length) {
            for (let j = i + 1; j < this.addUsers.data.length; j++) {
              if (this.addUsers.data[i].email === this.addUsers.data[j].email) {
                isDupEmail = true
              }
            }
          }
        }
        if (isDupEmail) {
          this.msgBoxError('Duplicate Email')
          this.addUsers.valid = false
          return
        }

        let emails = []
        for (let i = 0; i < this.addUsers.data.length; i++) {
          emails.push(this.addUsers.data[i].email)
        }

        let query = new QueryHash()

        query.add('filter', JSON.stringify({ email: { $in: emails } }))

        await getData(`/users/count?${query.toQueryString()}`).then((count) => {
          if (count > 0) {
            this.msgBoxError('Registered Email')
            this.addUsers.valid = false
          } else {
            if (this.addUsers.mode === 'input') {
              this.addUsers.mode = 'confirm'
              this.addUsers.editable = false
            } else {
              this.doAddUsers()
            }
          }
        })
      }
    },
    async onAddUsersBack () {
      this.addUsers.mode = 'input'
      this.addUsers.editable = true
      await this.checkAddUsers()
    },
    async doAddUsers () {
      this.mask = true

      let users = []
      for (let i = 0; i < this.addUsers.data.length; i++) {
        users.push(this.addUsers.data[i])
      }

      let message = null

      await postData(`/users`, { users: users }).then(async () => {
      }).catch((err) => {
        console.log(err)

        message = 'データの保存に失敗しました'
        if (err.response.data) {
          if (err.response.data.code && err.response.data.message) {
            message = err.response.data.message
          } else if (err.response.data.message) {
            message = err.response.data.message
          }
        }
      })

      this.mask = false

      if (message) {
        this.msgBoxError(message)
      } else {
        this.$bvModal.msgBoxOk('お申し込みが完了しました', {
          okTitle: '閉じる'
        }).then(() => {
          this.$bvModal.hide('modal-add')
          // this.$forceUpdate()
          this.loadData()
        })
      }
    }
  }
}
</script>

<style scoped lang="stylus">
.data.table-responsive
  overflow scroll
  min-height calc(100vh - 3.75rem - 5.5rem - 3.375rem - 3.375rem)

  >>> table
    tr.b-table-row-selected
      td
        background-color #fed

.notLoggedin
  display inline-block
  pointer-events none
  &.clickable
    pointer-events auto
    color #007bff
    font-weight 600

>>> #modal-add
  .modal-body
    margin-top 0
    padding 0
    .card
      border-radius 0
      background-color purple
      .card-body
        padding 2rem 1.5rem
        .card-title
          color white !important
          line-height 1.5rem
          .title
            font-size 1.2rem
          .sub-title
            font-size 0.875rem

    form.confirm
      input, select
        border 0 none
        border-radius 0
        border-bottom 1px solid #ddd
        background-color transparent !important
        &:-webkit-autofill
        &:-internal-autofill-selected
          background-color transparent !important
      select
        appearance none
</style>
